"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { useNavigationStore } from "./useNavigationStore";

export function NavigationTracker() {
    const pathname = usePathname();
    const setPath = useNavigationStore((s) => s.setPath);

    useEffect(() => {
        setPath(pathname);
    }, [pathname, setPath]);

    return null;
}
